import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, FormGroup, Label, Row } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { CLIENT_REPORT, EMPLOYEE_CLIENT_WISE_REPORT } from "../../helpers/url_helper";
import { DatePicker, DatePickerWithoutTime, DatePickerWithoutTimes } from "../../Components/Common/Flatpicker";
import SearchField from "../../Components/Common/SearchField";
import { formatDate } from "../../Components/Common/FormDateTime";
import { APIClient, exportReport } from "../../helpers/api_helper";
import { getPreviousDate, setCurrentDate } from "../../Components/Common/DefaultDateSet";
import { HandleErrorMessage } from "../../Components/Common/HandleErrorMessage";
import moment from "moment";
import SubExpired from "../../Components/Common/subExpired";
import { useProfileData } from "../../Components/Hooks/UserHooks";
import { useNavigate } from "react-router-dom";
import CommanDataTable from "../../Components/Common/DataTable";
import { formatToSystemTimezone } from "../../Components/Common/ToCamelCase";
import { addMonths } from "../../Components/Common/FlatePicker";
import { handleExport } from "../../Components/Common/validationSchema";
import CalculateRemainingDays from "../../Components/Common/CalculateRemainingDays";

const api = new APIClient();

const ClientReport = () => {
    document.title = "Client Report";
    const navigate = useNavigate();
    const previewsDate = getPreviousDate();
    const currentDate = setCurrentDate();
    const { profileData } = useProfileData();
    const [isLoading, setIsLoading] = useState(true);
    const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);
    // date picker state
    const [selectedFromDate, setSelectedFromDate] = useState(previewsDate);
    const [selectedToDate, setSelectedToDate] = useState(currentDate);
    const [detailsReport, setDetailsReport] = useState([])

    const [selectionMode, setSelectionMode] = useState("details");


    // search field state
    const [searchValue, setSearchValue] = useState("");

    // Pagination state
    const [totalRows, setTotalRows] = useState(0);
    const [totalDetailsRows, setTotalDetailsRow] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [perDetailsPage, setPerDetailsPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentDetailsPage, setCurrentDetailsPage] = useState(1);

    const [clientReport, setClientReport] = useState([]);
    //search field state
    const [query, setQuery] = useState("");
    const [queryDetails, setDetailsQuery] = useState("");
    const [debouncedQuery, setDebouncedQuery] = useState("");
    const [debouncedDetailsQuery, setDebouncedDetailsQuery] = useState("");
    const remainingDays = CalculateRemainingDays();

    const [show, setShow] = useState(false)

    const [appliedDateRange, setAppliedDateRange] = useState({
        startDate: previewsDate, // Initialize with current dates
        endDate: currentDate
    });
    const [appliedPhoneNumber, setAppliedPhoneNumber] = useState(
        searchValue.replace(/^\+91-/, "") // Initialize with current search value
    );


    // // flatPicker Date
    const formattedStartDate = formatDate(selectedFromDate);
    const formattedEndDate = formatDate(selectedToDate);

    const isWithinRange = (date) => {
        const today = new Date();
        return date >= selectedFromDate && date <= today;
    };

    const handleFromDateChange = (dates) => {
        const newFromDate = dates[0];
        setSelectedFromDate(newFromDate);
        const today = new Date();
        const threeMonthsAfterFromDate = addMonths(newFromDate, 3);

        if (selectedToDate >= newFromDate && selectedToDate <= threeMonthsAfterFromDate) {
            return;
        }
        const newToDate = threeMonthsAfterFromDate > today ? today : threeMonthsAfterFromDate;
        setSelectedToDate(newToDate);
    };

    const handleToDateChange = (dates) => {
        const newToDate = dates[0];
        if (isWithinRange(newToDate)) {
            setSelectedToDate(newToDate);
        } else {
            console.warn("Selected date is out of range.");
        }
    };



    const handleSelectionModeChange = (e) => {
        const newMode = e.target.value;
        setSelectionMode(newMode);

        // Reset search queries when switching modes
        setQuery("");
        setDetailsQuery("");
        setDebouncedQuery("");
        setDebouncedDetailsQuery("");

        // Trigger API call for the newly selected mode
        if (newMode === "details") {
            getSummaryReport(
                {
                    startDate: appliedDateRange.startDate,
                    endDate: appliedDateRange.endDate,
                    clientPhoneNumberOrName: appliedPhoneNumber
                }
            );
        } else if (newMode === "summary") {
            getDetailsReport(
                {
                    startDate: appliedDateRange.startDate,
                    endDate: appliedDateRange.endDate,
                    clientPhoneNumberOrName: appliedPhoneNumber
                }
            );
        }
    };


    // search field function
    const handleSearchField = (e) => {
        setSearchValue(e.target.value);
    };

    const column = [
        {
            name: <span className="font-weight-bold fs-13"> SN.</span>,
            width: "5%",
            selector: (row, index) => index + 1,
            sortable: true,
        },

        {
            name: (
                <span className="font-weight-bold fs-13 text-center" style={{ textTransform: "capitalize" }}>
                    Employee
                </span>
            ),
            selector: (row) => row?.fullName,
            cell: (row) => (
                <div className="mt-2 mb-2">
                    <h5 className="font-weight-bold fs-13" style={{ textTransform: "capitalize" }}>
                        {row?.fullName}
                    </h5>
                    <h6 className="text-center- font-weight-bold fs-13">
                        {row?.countryCode + `-` + row?.mobileNumber}
                    </h6>
                </div>
            ),
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13"> Team Name</span>,
            selector: (row) => row.team,
        },
        {
            name: <span>Client Name</span>,
            selector: (row) => row?.name,
            cell: (row) => (
                <div className="mt-2 mb-2">
                    <h5 className="font-weight-bold fs-13" style={{ textTransform: "capitalize" }}>
                        {row?.name}
                    </h5>
                    <h6 className="text-center- font-weight-bold fs-13">{row?.phoneNumber}</h6>
                </div>
            ),
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Date & Time</span>,
            selector: (row) => new Date(`${row?.date} ${row?.time}`).getTime(), // Timestamp for sorting
            cell: (row) => (
                <div className="mt-2 mb-2">
                    <h5 className="font-weight-bold fs-13" style={{ textTransform: "capitalize" }}>
                        {row?.date}
                    </h5>
                    <h6 className="text-center font-weight-bold fs-13">{row?.time}</h6>
                </div>
            ),
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Call Recording</span>,
            width: "37%",
            selector: (row) => (
                <>
                    {row?.recording ? (
                        <div
                            style={{
                                display: "inline-grid",
                                marginBottom: "20px",
                                marginTop: "10px",
                            }}
                        >
                            <span style={{ height: "10px" }}>{row?.duration}</span>
                            <audio style={{ height: "40px", marginTop: "15px" }} src={row?.recording} controls />
                        </div>
                    ) : row?.duration && row.duration !== "00:00:00" ? (
                        <div
                            style={{
                                display: "inline-grid",
                                marginBottom: "20px",
                                marginTop: "10px",
                            }}
                        >
                            {["OUTGOING", "INCOMING", "REJECTED", "MISSED"].includes(row.type) ? (
                                <>
                                    <span style={{ height: "10px" }}>{row?.duration}</span>
                                    <span style={{ marginTop: "10px", color: "warning" }}>
                                        Recording sync in progress...
                                    </span>
                                </>
                            ) : (
                                "Call Not Connected"
                            )}
                        </div>
                    ) : (
                        "Call Not Connected"
                    )}
                </>
            ),
        },

        {
            name: <span className="font-weight-bold fs-13">Call Type</span>,
            selector: (cell) => {
                switch (cell.type) {
                    case "OUTGOING":
                        return (
                            <>
                                <i className="mdi mdi-phone-outgoing sn-out-going-text" />{" "}
                                <span className="badge badge-soft-info sn-out-going-call"> {cell.type}</span>
                            </>
                        );
                    case "REJECTED":
                        return (
                            <>
                                <i className="mdi mdi-phone-cancel sn-reject-call-icontext" />
                                <span
                                    className="badge badge-soft-warning"
                                    style={{ color: "#eca8f7", background: "rgb(238 172 247 / 22%)" }}
                                >
                                    {" "}
                                    {cell.type}{" "}
                                </span>
                            </>
                        );
                    case "MISSED":
                        return (
                            <>
                                <i className="mdi mdi-phone-missed sn-out-missed-text" />{" "}
                                <span className="ml-4 badge badge-soft-danger sn-out-missed-call"> {cell.type} </span>
                            </>
                        );
                    case "INCOMING":
                        return (
                            <>
                                <i className="mdi mdi-phone-incoming sn-out-incoming-text" />
                                <span className="ml-4 badge badge-soft-success sn-out-incoming-call">
                                    {" "}
                                    {cell.type}{" "}
                                </span>
                            </>
                        );
                    default:
                        return <span className="badge badge-soft-success"> {cell.type} </span>;
                }
            },
            width: '200px'
        },

        {
            name: <span className="font-weight-bold fs-13">Notes</span>,
            selector: (row) => row.notes,
            sortable: true
        },
    ];



    const columnDetails = [
        {
            name: <span className="font-weight-bold fs-13"> SN.</span>,
            width: "5%",
            selector: (row, index) => index + 1,
            sortable: true,
        },

        {
            name: (
                <span className="font-weight-bold fs-13 text-center" style={{ textTransform: "capitalize" }}>
                    Employee
                </span>
            ),
            selector: (row) => row?.fullName,
            cell: (row) => (
                <div className="mt-2 mb-2">
                    <h5 className="font-weight-bold fs-13" style={{ textTransform: "capitalize" }}>
                        {row?.fullName}
                    </h5>
                    <h6 className="text-center- font-weight-bold fs-13">
                        {row?.countryCode + `-` + row?.mobileNumber}
                    </h6>
                </div>
            ),
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13"> Team Name</span>,
            selector: (row) => row.team,
        },
        {
            name: <span>Client Name</span>,
            selector: (row) => row?.name,
            cell: (row) => (
                <div className="mt-2 mb-2">
                    <h5 className="font-weight-bold fs-13" style={{ textTransform: "capitalize" }}>
                        {row?.name}
                    </h5>
                    <h6 className="text-center- font-weight-bold fs-13">{row?.phoneNumber}</h6>
                </div>
            ),
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Total call</span>,
            selector: (row) => row.totalCalls,
            cell: (row) => (
                <div className="mt-2 mb-2">
                    <h5 className="font-weight-bold fs-13">
                        {row?.totalCalls}
                    </h5>
                </div>
            ),
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Total Outgoing Calls</span>,
            selector: (row) => row.totalOutgoingCalls,
            cell: (row) => (
                <div className="mt-2 mb-2">
                    <h5 className="font-weight-bold fs-13">
                        {row?.totalOutgoingCalls}
                    </h5>
                </div>
            ),
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Total Incoming call</span>,
            selector: (row) => row.totalIncomingCalls,
            cell: (row) => (
                <div className="mt-2 mb-2">
                    <h5 className="font-weight-bold fs-13">
                        {row?.totalIncomingCalls}
                    </h5>
                </div>
            ),
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Total Rejected call</span>,
            selector: (row) => row.totalRejectedCalls,
            cell: (row) => (
                <div className="mt-2 mb-2">
                    <h5 className="font-weight-bold fs-13">
                        {row?.totalRejectedCalls}
                    </h5>
                </div>
            ),
            sortable: true,
        },

    ];

    // Debounce search query
    // Separate debounce for Summary search
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery(query);
            setCurrentPage(1);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [query]);

    // Separate debounce for Details search
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedDetailsQuery(queryDetails);
            setCurrentDetailsPage(1);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [queryDetails]);

    // Summary API call - only when summary tab is active
    useEffect(() => {
        const fetchSummaryData = async () => {
            if (selectionMode === 'details' && (debouncedQuery.length >= 3 || debouncedQuery.length === 0)) {
                await getSummaryReport(currentPage, perPage, debouncedQuery, {
                    startDate: appliedDateRange.startDate,
                    endDate: appliedDateRange.endDate,
                    clientPhoneNumberOrName: appliedPhoneNumber
                });
            }
        };
        fetchSummaryData();
    }, [debouncedQuery, currentPage, perPage, selectionMode]);

    // Details API call - only when details tab is active
    useEffect(() => {
        const fetchDetailsData = async () => {
            if (selectionMode === 'summary' && (debouncedDetailsQuery.length >= 3 || debouncedDetailsQuery.length === 0)) {
                await getDetailsReport(currentDetailsPage, perDetailsPage, debouncedDetailsQuery, {
                    startDate: appliedDateRange.startDate,
                    endDate: appliedDateRange.endDate,
                    clientPhoneNumberOrName: appliedPhoneNumber
                });
            }
        };
        fetchDetailsData();
    }, [debouncedDetailsQuery, currentDetailsPage, perDetailsPage, selectionMode]);



    // Search field handlers
    const handleSearch = (e) => {
        setQuery(e.target.value);
    };

    const handleDetailsSearch = (e) => {
        setDetailsQuery(e.target.value);
    };

    // table data
    const handleSubmit = () => {
        const extractedNumber = searchValue.replace(/^\+91-/, "");
        // Save the applied values when submit is clicked
        setAppliedDateRange({
            startDate: formattedStartDate,
            endDate: formattedEndDate
        });
        setAppliedPhoneNumber(extractedNumber);

        // Call API immediately with new values
        clientgetReport(1, 10, "", {
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            clientPhoneNumberOrName: extractedNumber
        });


        // clientgetReport(currentPage, 10); //perpage
        setCurrentPage(1);
        setCurrentDetailsPage(1)
        setPerPage(10);
        setPerDetailsPage(10)
    };

    // Pagination handler
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };


    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };



    const handleDetailsPageChange = (page) => {
        setCurrentDetailsPage(page)
    };

    const handleDetailsPerRowsChange = (newPerPage, page) => {
        setPerDetailsPage(newPerPage);
        setCurrentDetailsPage(page)
    };


    // Separate API functions
    const getSummaryReport = async (page, size, searchTerm, filterData) => {
        setIsLoading(true);
        try {
            let data = {
                startDate: filterData.startDate,
                endDate: filterData.endDate,
                clientPhoneNumberOrName: filterData.clientPhoneNumberOrName,
            };

            const response = await api.create(`${CLIENT_REPORT}?pg=${page}&lm=${size}&query=${searchTerm}`, data);

            if (response?.success) {
                const apiResponse = response.data;
                const clientReportType = apiResponse?.paginatedResults.map((report) => ({
                    date: report.dateTime ? moment(report.dateTime).format("DD MMM YYYY") : "-",
                    time: report.dateTime ? moment(report.dateTime).format("hh:mm A") : "-",
                    name: report.name || "Unknown",
                    phoneNumber: report.phoneNumber || "-",
                    type: report.type || "Unknown",
                    notes: report.note || "-",
                    fullName: report.employeeDescription?.[0]?.fullName || "Unknown",
                    mobileNumber: report.employeeDescription?.[0]?.mobileNumber || "-",
                    duration: new Date(report.duration * 1000).toISOString().slice(11, 19),
                    recording: report.callRecording || null,
                    countryCode: report?.employeeDescription[0]?.countryCode,
                    team: report?.employeeDescription[0]?.team[0] || 'No Team'
                }));

                setClientReport(clientReportType);
                setTotalRows(apiResponse.totalCount);
            }
        } catch (error) {
            HandleErrorMessage(error);
        } finally {
            setIsLoading(false);
        }
    };

    const getDetailsReport = async (page, size, searchTerm, filterData) => {
        setIsLoading(true);
        try {
            let data = {
                startDate: filterData.startDate,
                endDate: filterData.endDate,
                clientPhoneNumberOrName: filterData.clientPhoneNumberOrName,
            };

            const response = await api.create(`${EMPLOYEE_CLIENT_WISE_REPORT}?pg=${page}&lm=${size}&query=${searchTerm}`, data);

            if (response?.success) {
                const detailsResponse = response.data;
                const detailsReportType = detailsResponse?.paginatedResults.map((report) => ({
                    totalCalls: report.totalCalls || "-",
                    totalOutgoingCalls: report.totalOutgoingCalls || "-",
                    totalIncomingCalls: report.totalIncomingCalls || "-",
                    totalMissedCalls: report.totalMissedCalls || "-",
                    totalRejectedCalls: report.totalRejectedCalls || "-",
                    name: report.name || "Unknown",
                    phoneNumber: report.phoneNumber || "-",
                    fullName: report.employeeDescription?.[0]?.fullName || "Unknown",
                    mobileNumber: report.employeeDescription?.[0]?.mobileNumber || "-",
                    countryCode: report?.employeeDescription[0]?.countryCode,
                    team: report?.employeeDescription[0]?.team[0] || 'No Team'
                }));

                setDetailsReport(detailsReportType);
                setTotalDetailsRow(detailsResponse.totalCount);
            }
        } catch (error) {
            HandleErrorMessage(error);
        } finally {
            setIsLoading(false);
        }
    };



    const clientgetReport = async (page, size, searchTerm = "", filterData) => {
        setIsLoading(true);
        // const extractedNumber = searchValue.replace(/^\+91-/, "");
        try {
            let data = {
                startDate: filterData.startDate,
                endDate: filterData.endDate,
                clientPhoneNumberOrName: filterData.clientPhoneNumberOrName,
            };

            const [clientResponse, employeeResponse] = await Promise.all([
                api.create(`${CLIENT_REPORT}?pg=${page}&lm=${size}&query=${searchTerm}`, data),
                api.create(`${EMPLOYEE_CLIENT_WISE_REPORT}?pg=${page}&lm=${size}&query=${searchTerm}`, data)
            ]);
            if (clientResponse?.success || employeeResponse?.success) {

                setIsLoading(false);
                const apiResponse = clientResponse.data;
                const detailsResponse = employeeResponse.data

                if (apiResponse?.paginatedResults?.length > 0) {
                    setShow(true)
                }
                const clientReportType = apiResponse?.paginatedResults.map((report) => ({
                    date: report.dateTime ? moment(report.dateTime).format("DD MMM YYYY") : "-",
                    time: report.dateTime ? moment(report.dateTime).format("hh:mm A") : "-",
                    name: report.name || "Unknown",
                    phoneNumber: report.phoneNumber || "-",
                    type: report.type || "Unknown",
                    notes: report.note || "-",
                    fullName: report.employeeDescription?.[0]?.fullName || "Unknown",
                    mobileNumber: report.employeeDescription?.[0]?.mobileNumber || "-",
                    duration: new Date(report.duration * 1000).toISOString().slice(11, 19),
                    recording: report.callRecording || null,
                    countryCode: report?.employeeDescription[0].countryCode,
                    team: report?.employeeDescription[0]?.team[0] || 'No Team'
                }));


                const detailsReportType = detailsResponse?.paginatedResults.map((report) => ({
                    totalCalls: report.totalCalls || "-",
                    totalOutgoingCalls: report.totalOutgoingCalls || "-",
                    totalIncomingCalls: report.totalIncomingCalls || "-",
                    totalMissedCalls: report.totalMissedCalls || "-",
                    totalRejectedCalls: report.totalRejectedCalls || "-",
                    name: report.name || "Unknown",
                    phoneNumber: report.phoneNumber || "-",
                    fullName: report.employeeDescription?.[0]?.fullName || "Unknown",
                    mobileNumber: report.employeeDescription?.[0]?.mobileNumber || "-",
                    countryCode: report?.employeeDescription[0].countryCode,
                    team: report?.employeeDescription[0]?.team[0] || 'No Team'
                }));

                setDetailsReport(detailsReportType)
                setClientReport(clientReportType);

                setTotalRows(apiResponse.totalCount);
                setTotalDetailsRow(detailsResponse.totalCount)
            }
        } catch (error) {
            HandleErrorMessage(error);
        } finally {
            setIsLoading(false);
        }
    };



    const handleClose = () => {
        setIsExpiredModalOpen(false);
        navigate("/planPackage");
    };

    //export in excel
    const handleExcelExport = async () => {
        const extractedNumber = searchValue.replace(/^\+91-/, "");
        await handleExport({
            type: "excel",
            apiUrl: `${CLIENT_REPORT}`,
            startDate: selectedFromDate,
            endDate: selectedToDate,
            clientPhoneNumberOrName: `${extractedNumber}`,
            fileName: "ClientReport.xlsx",
        });
    };

    //export in pdf
    const handlePdfExport = async () => {
        const extractedNumber = searchValue.replace(/^\+91-/, "");
        await handleExport({
            type: "pdf",
            apiUrl: `${CLIENT_REPORT}`,
            startDate: selectedFromDate,
            endDate: selectedToDate,
            clientPhoneNumberOrName: `${extractedNumber}`,
            fileName: "ClientReport.pdf",
        });
    };



    return (
        <React.Fragment>
            {remainingDays === 0 && isExpiredModalOpen && (
                <SubExpired
                    onClose={handleClose}
                    profileData={profileData?.selectedPlanDetails?.planName}
                    remainingDays={remainingDays}
                />
            )}
            <div className="page-content sn-client-report-main-page">
                <Container fluid>
                    <BreadCrumb title="Search Client" pageTitle="Client Report" />
                    <Row>
                        <Col lg={12}>
                            <Card className="h-100">
                                {/* <CardHeader>
                                    <h4 className="card-title mb-0">Client Report</h4>
                                </CardHeader> */}
                                <CardBody>
                                    <Row className="sn-header-select-employess-home sn-top-inputs-heading-">
                                        <div className="col-md-3 col-sm-12">
                                            <DatePicker
                                                labelContent="From Date"
                                                getDate={selectedFromDate}
                                                options={{
                                                    disable: [
                                                        {
                                                            from: new Date(),
                                                        },
                                                    ],
                                                    dateFormat: "d M, Y",
                                                    maxDate: new Date(
                                                        new Date().setDate(new Date().getDate())
                                                    ),
                                                }}
                                                onChange={handleFromDateChange}
                                            />
                                        </div>

                                        <div className="col-md-4 col-sm-12 sn-header-select-employess-home">
                                            <DatePicker
                                                labelContent="To Date"
                                                getDate={selectedToDate}
                                                options={{
                                                    dateFormat: "d M, Y",
                                                    minDate: selectedFromDate,
                                                    // maxDate: 'today',
                                                    enable: [
                                                        {
                                                            from: selectedFromDate,
                                                            to: Math.min(
                                                                addMonths(selectedFromDate, 3),
                                                                new Date()
                                                            ),
                                                        },
                                                    ],
                                                    onOpen: () => {
                                                        const currentDate = new Date();
                                                        const threeMonthsFromStart = addMonths(
                                                            selectedFromDate,
                                                            3
                                                        );
                                                        if (threeMonthsFromStart > currentDate) {
                                                            return {
                                                                enable: [
                                                                    {
                                                                        from: selectedFromDate,
                                                                        to: currentDate,
                                                                    },
                                                                ],
                                                            };
                                                        }
                                                    },
                                                }}
                                                onChange={handleToDateChange}
                                            />
                                        </div>

                                        <div className="col-md-3 col-sm-12 sn-header-select-employess-home">
                                            <SearchField
                                                onChange={handleSearchField}
                                                labelContent="Search by Client details"
                                            />
                                        </div>
                                        <div className="col-md-2 col-sm-12 mt-2">
                                            <FormGroup>
                                                <Label for="exampleSelect"></Label>
                                                <div id="exampleSelect" className="sn-call-apply-btn-reset">
                                                    <Button
                                                        type="submit"
                                                        color="danger"
                                                        className=""
                                                        onClick={handleSubmit}
                                                    // disabled={isLoading}
                                                    >
                                                        Get Report
                                                    </Button>
                                                </div>
                                            </FormGroup>
                                        </div>
                                    </Row>

                                    <Row className="sn-user-tble-manin-manage">

                                        {show === true ? <div className="p-4 rounded-lg mb-6">
                                            <div
                                                className="flex gap-6 radio-group-sn"
                                                style={{ display: "flex", gap: "23px" }}
                                            >
                                                <label className="flex items-center gap-2 cursor-pointer radio-option-sn">
                                                    <input
                                                        type="radio"
                                                        name="selectionMode"
                                                        value="details"
                                                        checked={selectionMode === "details"}
                                                        onChange={handleSelectionModeChange}
                                                        className="text-blue-500"
                                                    />
                                                    <span className="text-sm">Details</span>
                                                </label>
                                                <label className="flex items-center gap-0 cursor-pointer radio-option-sn">
                                                    <input
                                                        type="radio"
                                                        name="selectionMode"
                                                        value="summary"
                                                        checked={selectionMode === "summary"}
                                                        onChange={handleSelectionModeChange}
                                                        className="text-blue-500"
                                                    />
                                                    <span className="text-sm">Summary</span>
                                                </label>
                                            </div>
                                        </div> : ''}


                                        <Col lg={12}>
                                            {selectionMode === "details" && <div className="text-end">
                                                {clientReport?.length > 0 ? (
                                                    <div
                                                        className="sales-ninja-tble-export-btn call-logs-report-export-exe"
                                                        style={{ position: "relative" }}
                                                    >
                                                        {" "}
                                                        <Button
                                                            onClick={handleExcelExport}
                                                            className="custom-button tble-export1 sn-report-export-btn-new"
                                                        >
                                                            <i className="ri-file-excel-line"></i>
                                                        </Button>{" "}
                                                        &nbsp;
                                                        <Button
                                                            onClick={handlePdfExport}
                                                            className="custom-button ml-2 tble-export1 tble-export2 sn-report-export-btn-new button-file-export-pdf"
                                                        >
                                                            <i className="las la-file-pdf"></i>
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </div>}
                                            <div className="sn-client-report-table-main">
                                                {selectionMode === 'details' && <CommanDataTable
                                                    className="mt-0 pt-0"
                                                    column={column}
                                                    setCurrentPage={setCurrentPage}
                                                    perPage={perPage}
                                                    handleSearch={handleSearch}
                                                    tableData={clientReport}
                                                    handlePerRowsChange={handlePerRowsChange}
                                                    totalRows={totalRows}
                                                    currentPage={currentPage}
                                                    isLoading={isLoading}
                                                    handlePageChange={handlePageChange}
                                                    noData="There are no records to display"
                                                    inputClass={
                                                        (clientReport && clientReport.length > 0) || query
                                                            ? "d-block"
                                                            : "d-none"
                                                    }
                                                />}
                                            </div>

                                            <div className="sn-client-report-table-main">
                                                {selectionMode === 'summary' && <CommanDataTable
                                                    className="mt-0 pt-0"
                                                    column={columnDetails}
                                                    setCurrentPage={setCurrentDetailsPage}
                                                    perPage={perDetailsPage}
                                                    handleSearch={handleDetailsSearch}
                                                    tableData={detailsReport}
                                                    handlePerRowsChange={handleDetailsPerRowsChange}
                                                    totalRows={totalDetailsRows}
                                                    currentPage={currentDetailsPage}
                                                    isLoading={isLoading}
                                                    handlePageChange={handleDetailsPageChange}
                                                    noData="There are no records to display"
                                                    inputClass={
                                                        (detailsReport && detailsReport.length > 0) || queryDetails
                                                            ? "d-block"
                                                            : "d-none"
                                                    }
                                                />}
                                            </div>

                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ClientReport;
